import PropTypes from 'prop-types';

const displayName = 'DetailProduct';
const propTypes = {};
const defaultProps = {};

export default { displayName, propTypes, defaultProps };
